/* global fbq */

import React, { useEffect, useRef, useState } from "react";
import classes from "./WebApp.module.css";
import { useGoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { ENV, path } from "../../path";
import AppleIcon from "@mui/icons-material/Apple";
import { useDispatch } from "react-redux";
import { getRandomUserName } from "../LandingPage/UsernameGenration";
import CloseIcon from '@mui/icons-material/Close';
import ReactGA from 'react-ga4'
import { v4 as uuid } from 'uuid'
import { getStoredAttribution } from "../../Utils/attribution";
import { logAuthError } from "../../Utils/Analytics";
import { toast } from "react-toastify";

function SignUpModal({ setSignUpModalOpen, type, register, registerWithPayment, registerSlotWithPayment, paymentType }) {
  const dispatch = useDispatch();
  //   const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const attemptId = useRef(null)

  const clientId = "feedants.com";
  const scope = "name email";
  const redirectURI = "https://www.feedants.com/";
  const state = "origin:web";

  useEffect(() => {
    window.AppleID?.auth.init({
      clientId,
      scope,
      redirectURI,
      state,
      usePopup: true,
    });

    const handleAppleSignInSuccess = async (event) => {
      console.log("Success ", event);
      await AppleSignInFunc(event);
    };

    const handleAppleSignInFailure = (event) => {
      console.log("Error ", event);
    };

    document.addEventListener(
      "AppleIDSignInOnSuccess",
      handleAppleSignInSuccess
    );
    document.addEventListener(
      "AppleIDSignInOnFailure",
      handleAppleSignInFailure
    );

    return () => {
      document.removeEventListener(
        "AppleIDSignInOnSuccess",
        handleAppleSignInSuccess
      );
      document.removeEventListener(
        "AppleIDSignInOnFailure",
        handleAppleSignInFailure
      );
    };
  }, []);


  const googleLogin = useGoogleLogin({
    scope:
      "https://www.googleapis.com/auth/user.birthday.read https://www.googleapis.com/auth/user.gender.read",
    onSuccess: async ({ access_token }) => {
      setIsLoading(true);
      try {
        // console.log(access_token);
        const userInfo = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          { headers: { Authorization: `Bearer ${access_token}` } }
        );
        const extraData = await axios.get(
          "https://people.googleapis.com/v1/people/me?personFields=birthdays,genders",
          { headers: { Authorization: `Bearer ${access_token}` } }
        );
        await GoogleSignInFunc(userInfo, extraData);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        // setError(true);
        setIsLoading(false);
        console.log(error);
      }
    },
    onFailure: () => {
      //   setError(true);
      setIsLoading(false);
    },
  });

  const GoogleSignInFunc = async (userInfo, extraData) => {
    try {
      await storeAttempts('google (web)', 'login')
      const mailCheck = await checkEmail(userInfo?.data?.email);
      if (mailCheck) {
        await SetUser(mailCheck);
        setSignUpModalOpen(false);
        await updateAttempt('success', 'login')
        if (ENV === "prod") {
          ReactGA.event("login", { method: `google.com (web)` })
          fbq('trackCustom', "login", { method: `google.com (web)`, email: mailCheck?.data?.user?.email || "" })
        }
        return;
      }

      const googleUser = {
        firstname: userInfo?.data?.given_name,
        lastname: userInfo?.data?.family_name,
        email: userInfo?.data?.email,
        gender: extraData?.data?.genders?.[0]?.value,
        birthday: extraData?.data?.birthdays?.[0]?.date,
      };

      await SignUp(googleUser, "google");
      //   SendHGoogleEvent("google signup", "User signup Successfull");
    } catch (error) {
      console.log("error :", error)
      await updateAttempt('error', 'login')
      await logAuthError({
        email: userInfo?.data?.email || "",
        error: error.message || JSON.stringify(error),
        authType: "Google login/signup",
      });

    }
  };

  const AppleSignInFunc = async (event) => {
    try {
      await storeAttempts('apple (web)', 'login')
      const decodedToken = jwtDecode(event?.detail?.authorization?.id_token);

      if (event?.detail?.user) {
        const mailCheck = await checkEmail(event?.detail?.user?.email, decodedToken.sub);
        if (mailCheck !== null) {
          await SetUser(mailCheck);
          setSignUpModalOpen(false)
          await updateAttempt('success', 'login')
          if (ENV === "prod") {
            ReactGA.event("login", { method: `apple.com login (web)` })
            fbq('trackCustom', "login", { method: `apple.com login (web)`, email: mailCheck?.data?.user?.email || "" })
          }
          return;
        }

        const appleUser = {
          firstname: event?.detail?.user?.name?.firstName,
          lastname: event?.detail?.user?.name?.lastName,
          email: event?.detail?.user?.email,
          appleUserId: decodedToken.sub
        };

        await SignUp(appleUser, "apple");
      } else {
        // console.log(email);
        const mailCheck = await checkEmail(decodedToken.email, decodedToken.sub);
        // console.log(mailCheck);
        if (mailCheck !== null) {
          await SetUser(mailCheck);
          setSignUpModalOpen(false);
          await updateAttempt('success', 'login')
          if (ENV === "prod") {
            ReactGA.event("login", { method: `apple.com login (web)` })
            fbq('trackCustom', "login", { method: `apple.com login (web)`, email: mailCheck?.data?.user?.email || "" })
          }
        } else {
          toast.error("There was a error getting apple user, Please goto Settings > Apple ID, iCloud, iTunes & App Store > Password & Security > Apps Using Your Apple ID, tap on Feedants, and tap Stop Using Apple ID.")
        }
      }
    } catch (error) {
      console.log("error:", error)
      await updateAttempt('error', 'login')
      await logAuthError({
        email: event?.detail?.user?.email || "",
        error: error.message || JSON.stringify(error),
        authType: "Apple login/signup",
      })
    }
  };

  const SignUp = async (socialUser, type) => {
    const config = {
      host: `${path}`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": `${path}`,
      },
    };

    try {
      let datee = null;
      if (
        socialUser?.birthday?.year !== undefined &&
        socialUser?.birthday?.month !== undefined &&
        socialUser?.birthday?.day !== undefined
      ) {
        datee = new Date();
        datee.setFullYear(socialUser?.birthday?.year);
        datee.setMonth(socialUser?.birthday?.month);
        datee.setDate(socialUser?.birthday?.day);
      }
      console.log(datee);
      const username = await getRandomUserName(
        socialUser?.firstname,
        socialUser?.lastname
      );
      //get attribution data comming from Meta
      const attribution = getStoredAttribution();
      // console.log(username);
      let response = null;
      if (type === "google") {
        response = await axios.post(
          `${path}/v2/googlesignup`,
          {
            firstName: socialUser?.firstname,
            lastName: socialUser?.lastname,
            gender: socialUser?.gender,
            username: username,
            email: socialUser?.email,
            birthdate: datee,
            attribution: attribution || null,
            platform: "web"
          },
          config
        );
      } else {
        response = await axios.post(
          `${path}/v2/applesignup`,
          {
            firstName: socialUser?.firstname,
            lastName: socialUser?.lastname,
            username: username,
            email: socialUser?.email,
            appleUserId: socialUser?.appleUserId,
            attribution: attribution || null,
            platform: "web"
          },
          config
        );
      }

      if (response?.data?.success === true) {
        await updateAttempt('success', 'signup')
        if (ENV === "prod") {
          ReactGA.event("sign_up", { method: `${type}.com signUp (web)` })
          fbq('trackCustom', "sign_up", { method: `${type}.com signUp (web)`, email: response?.data?.user?.email || "" })
        }
        await SetUser(response);
      } else if (response?.data?.success === false) {
        //   toast.error(response?.data?.msg, toastOption);
        console.log(response?.data?.msg);
      }
      setSignUpModalOpen(false)
    } catch (err) {
      await updateAttempt('error', 'signup')
      console.log(err);
      throw new Error(err?.message || JSON.stringify(err));
    }
  };

  const SetUser = async (response) => {
    try {
      localStorage.setItem("myToken", response.data.token);
      const date = new Date();

      await dispatch({
        type: "SET_USER",
        token: response.data.token,
        user: response.data.user,
        loginTime: date.getMinutes(),
      });


      if (registerWithPayment && paymentType === "Prepaid") {
        registerWithPayment(response.data.user);
      } else if (register && paymentType === "Postpaid") {
        register(response.data.user);
      } else if (registerSlotWithPayment && paymentType === "Slotpaid") {
        registerSlotWithPayment(response.data.user)
      }

      setSignUpModalOpen(false);

    } catch (error) {
      console.info(error);
      throw new Error(error?.message || JSON.stringify(error));
    }
  };


  const checkEmail = async (email, appleUserId) => {
    try {
      const response = await axios.post(`${path}/checkemail`, {
        email,
        appleUserId
      });

      if (response?.data?.success === true) {
        return response;
      }
      // console.log(response);
      return null;
    } catch (err) {
      console.log(err);
      throw new Error(err?.message || JSON.stringify(err));
    }
  };

  const storeAttempts = async (type, kind) => {
    try {
      let uniqueId = localStorage.getItem('unique_device_id')
      if (!uniqueId) {
        uniqueId = uuid();
        localStorage.setItem('unique_device_id', uniqueId);
      }
      const response = await axios.post(`${path}/analytics/attempt`, { type, uniqueId, kind })
      if (response.data.success) {
        attemptId.current = response.data.id;
      }
    } catch (error) {
      console.log("Error while storing login attempt", error)
    }
  }

  const updateAttempt = async (status, kind) => {
    try {
      if (attemptId.current) {
        const id = attemptId.current
        await axios.patch(`${path}/analytics/attempt/${id}`, { status, kind })
        attemptId.current = null;
      }
    } catch (error) {
      console.log(`Error while updating attempt`, error)
    }
  }

  return (
    <div
      className=" fixed inset-0 bg-black/40 z-10 flex items-center justify-center p-4 "
    >
      <div
        className=" relative p-4 w-full max-w-md bg-white rounded-lg z-20 flex item-center justify-center  "
      >
        <span className=" absolute top-2 right-2" onClick={() => setSignUpModalOpen(false)}>
          <CloseIcon className=" text-gray-600 cursor-pointer" />
        </span>
        <div>
          {!isLoading && (
            <div className="text-center text-lg text-medium text-gray-900">
              SignUp {type === "register" ? "to Register" : type === "applyAsJudge" ? "to Apply" : ""}
            </div>
          )}
          {isLoading && (
            <div className=" flex gap-2 items-center ">
              {" "}
              <p className=" border-2 border-t-white border-teal-400 size-5 rounded-full animate-spin" />
              Signing...
            </div>
          )}
          <div className="flex justify-center mt-2 gap-2">
            <button
              className={classes.gsi_material_button}
              onClick={() => {
                googleLogin();
              }}
              disabled={isLoading}>
              <div className={classes.gsi_material_button_content_wrapper}>
                <div className={classes.gsi_material_button_icon}>
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 48 48"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    style={{ display: "block" }}>
                    {/* Your Google icon paths */}
                    <path
                      fill="#EA4335"
                      d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                    <path
                      fill="#4285F4"
                      d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                    <path
                      fill="#FBBC05"
                      d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                    <path
                      fill="#34A853"
                      d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                    <path fill="none" d="M0 0h48v48H0z"></path>
                  </svg>
                </div>
              </div>
            </button>
            <button
              onClick={() => window.AppleID.auth.signIn()}
              className="p-2 bg-white rounded-full border-black border flex text-center items-center justify-center">
              <AppleIcon />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUpModal;
